export default __webpack_public_path__ + "static/image1-fa48ec27a47a550c985049f047baa010.jpeg";